import { KeyValuePair } from '../../models';

export function getDefaultSubtype(model: string, properties: KeyValuePair<string, string>[]) {
    if (properties.length && (!model || properties.map(d => d.key).indexOf(model) < 0)) {
        const defaultSubTypes = properties.filter(d => d.value.toLowerCase() === 'std'
            || d.value.toLowerCase() === 'relative');
        if (defaultSubTypes.length) {
            model = defaultSubTypes[0].key;
        }
    }
    return model;
}

export function getDefaultQualifier(model: string, properties: KeyValuePair<string, string>[]) {
    if (properties.length && (!model || properties.map(d => d.key).indexOf(model) < 0)) {
        const defaultQualifiers = properties.filter(d => d.value.toLowerCase() === 'total');
        if (defaultQualifiers.length) {
            model = defaultQualifiers[0].key;
        }
    }
    return model;
}